var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-wrap-new m-pc",style:({
    background:
      _vm.extras1.formBg.colorOrBg == 'color'
        ? _vm.extras1.formBg.color
        : 'url(' + _vm.extras1.formBg.src + ')',
  })},[(_vm.extras1 && _vm.extras1.formLogo.display == '1')?_c('div',{staticClass:"semianr-logo"},[_c('img',{attrs:{"src":_vm.isSetting != '1'
          ? _vm.extras1.headerLogo && _vm.extras1.headerLogo.src
          : './images/logo_new.png',"alt":""}})]):_vm._e(),(_vm.isSetting != '1')?_c('div',{staticClass:"seminar-info"},[(_vm.extras1 && _vm.extras1.textSetting.display == '1')?_c('div',{staticClass:"seminar-info-new",class:_vm.extras1.BannerText.textAlign},[_c('div',{staticClass:"content"},[(_vm.extras1.textSetting.subTitle !== 'hide')?_c('div',{staticClass:"seminar-title",style:({
            color:
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontColor
                : '',
            'font-size':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontSize + 'px'
                : '',
            'font-weight':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontWeight == 'on'
                  ? '900'
                  : ''
                : '',
            'font-style':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
          })},[_vm._v(" "+_vm._s(_vm.getSubTitleText())+" ")]):_vm._e(),(_vm.extras1.textSetting.title !== 'hide')?_c('div',{staticClass:"seminar-slogan",style:({
            color:
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontColor
                : '',
            'font-size':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontSize + 'px'
                : '',
            'font-weight':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontWeight == 'on'
                  ? '900'
                  : ''
                : '',
            'font-style':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
          })},[_vm._v(" "+_vm._s(_vm.getTitleText())+" ")]):_vm._e(),_c('div',{staticClass:"semianr-time"},[(_vm.extras1.textSetting.timeTitle !== 'hide')?_c('div',{staticClass:"_title",style:({
              color:
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontColor
                  : '',
              'font-size':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontSize + 'px'
                  : '',
              'font-weight':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'font-style':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'background-color':
                _vm.extras1.textSetting && _vm.extras1.textSetting.titleBgColor
                  ? _vm.extras1.textSetting.titleBgColor
                  : 'transparent',
            })},[_vm._v(" "+_vm._s(_vm.getTimeTitleText())+" ")]):_vm._e(),(_vm.extras1.textSetting.time !== 'hide')?_c('div',{staticClass:"_time",style:({
              color:
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontColor
                  : '',
              'font-size':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontSize + 'px'
                  : '',
              'font-weight':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'font-style':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'background-color':
                _vm.extras1.textSetting && _vm.extras1.textSetting.timeBgColor
                  ? _vm.extras1.textSetting.timeBgColor
                  : 'transparent',
            })},[_vm._v(" "+_vm._s(_vm.getTimeText())+" ")]):_vm._e()])])]):_vm._e()]):_vm._e(),(_vm.isSetting == '1')?_c('div',{staticClass:"seminar-info"},[(_vm.extras1 && _vm.extras1.textSetting.display == '1')?_c('div',{staticClass:"seminar-info-new"},[_c('div',{staticClass:"content"},[(_vm.extras1.textSetting.subTitle !== 'hide')?_c('div',{staticClass:"seminar-title",style:({
            color:
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontColor
                : '',
            'font-size':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontSize + 'px'
                : '',
            'font-weight':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontWeight == 'on'
                  ? '900'
                  : ''
                : '',
            'font-style':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
          })},[_vm._v(" 2023企业数字化峰会 ")]):_vm._e(),(_vm.extras1.textSetting.title !== 'hide')?_c('div',{staticClass:"seminar-slogan",style:({
            color:
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontColor
                : '',
            'font-size':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontSize + 'px'
                : '',
            'font-weight':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontWeight == 'on'
                  ? '900'
                  : ''
                : '',
            'font-style':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
          })},[_vm._v(" 设计连接 新商业 ")]):_vm._e(),_c('div',{staticClass:"semianr-time"},[(_vm.extras1.textSetting.timeTitle !== 'hide')?_c('div',{staticClass:"_title",style:({
              color:
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontColor
                  : '',
              'font-size':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontSize + 'px'
                  : '',
              'font-weight':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'font-style':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'background-color':
                _vm.extras1.textSetting && _vm.extras1.textSetting.titleBgColor
                  ? _vm.extras1.textSetting.titleBgColor
                  : 'transparent',
            })},[_vm._v(" "+_vm._s(_vm.$t("success.meetingTime"))+" ")]):_vm._e(),(_vm.extras1.textSetting.time !== 'hide')?_c('div',{staticClass:"_time",style:({
              color:
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontColor
                  : '',
              'font-size':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontSize + 'px'
                  : '',
              'font-weight':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'font-style':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'background-color':
                _vm.extras1.textSetting && _vm.extras1.textSetting.timeBgColor
                  ? _vm.extras1.textSetting.timeBgColor
                  : 'transparent',
            })},[_vm._v(" "+_vm._s("2023.12.12-12.13")+" ")]):_vm._e()])])]):_vm._e()]):_vm._e(),_c('div',{staticClass:"field-area success",style:({
      background:
        _vm.extras1.formFieldBg.colorOrBg == 'color'
          ? _vm.extras1.formFieldBg.color
          : 'url(\'' + _vm.extras1.formFieldBg.src.replace(/'/g, '\\\'') + '\')',
    })},[(!_vm.signSuccess && (_vm.isRefuse == '0' || _vm.isRefuse == null))?_c('SuccessCon',{attrs:{"platform":_vm.platform}}):_vm._e(),(!_vm.signSuccess && _vm.isRefuse != '0' && _vm.isRefuse != null)?_c('RefuseCon',{attrs:{"platform":_vm.platform}}):_vm._e(),(_vm.signSuccess)?_c('SuccessPartCon',{attrs:{"platform":_vm.platform,"category":_vm.category}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }